import styles from './index.module.scss'
import { Anchor as AntdAnchor } from 'antd';
const Anchor = ({ items }) => {
    return (
        <div className={styles.anchor}>
            <AntdAnchor
                getContainer={() => document.getElementById('chartView')}
                items={items}
            />
        </div>
    )
}

export default Anchor
